import { useEffect, useState } from "react";

type GeolocationPermissionState = "granted" | "denied" | "prompt" | "unsupported";

export const useGeolocationPermission = (): GeolocationPermissionState => {
    const [permissionState, setPermissionState] = useState<GeolocationPermissionState>("prompt");

    useEffect(() => {
        if (!navigator.permissions || !navigator.permissions.query) {
            setPermissionState("unsupported");
            return;
        }

        navigator.permissions.query({ name: "geolocation" }).then((result) => {
            setPermissionState(result.state as GeolocationPermissionState);

            // Watch for changes to permission
            result.onchange = () => {
                setPermissionState(result.state as GeolocationPermissionState);
            };
        });
    }, []);

    return permissionState;
};
